import ApiService from '@/api/ApiService'
import proxy from '@/shared/proxy'

const AuthenticationService = {
  CreateSession (identifier: string, password: string) {
    return ApiService.postAsync(proxy.Securityv2, 'Security/Session/WebUser/Login',
      {
        Identifier: identifier,
        Password: password
      })
  },
  VaerifyUserLogin (identifier: string, password: string) {
    return ApiService.postAsync(proxy.Securityv2, 'Security/VaerifyUser/Login',
      {
        Identifier: identifier,
        Password: password
      })
  },
  CreateSessionRaw () {
    return ApiService.putAsync(proxy.Securityv1, 'Security/Session/Create', '')
  }
}
export default AuthenticationService
